import { Config } from '../core/config'
import Analytics from './analytics'

const chooseVariant = function () {
    if (Config.ABTesting.experimentId) {
        var variant = !Config.ABTesting.variant ? Config.ABTesting.defaultVariant : Config.ABTesting.variant;
        Analytics.trackABTesting(Config.ABTesting.experimentId, variant);
    }
}

export default {chooseVariant}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/helpers/abTesting.js